
<!--US Page-->
<div class="dtfwebsupporttechreqs" *ngIf="!isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


    <!--Banner-->
    <section class="mbfs-home-hero"  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Website_ContactUs_Header.jpg);">
      <section class="mbfs-home-hero__header">
       <h2 class="mbfs-home-hero__header-subtitle">
            {{ 'SiteSupport.Title' | translate }}
        </h2>
         <p class="subheader">
            
         </p>
        
      </section>
    </section>
    
    <p>{{ 'SiteSupport.TitleItem1' | translate }}
      <ul>
         <li><a href="https://support.apple.com/downloads/safari" target="_blank">{{ 'SiteSupport.Browser1' | translate }}</a></li>
         <li><a href="https://www.google.com/chrome/" target="_blank">{{ 'SiteSupport.Browser2' | translate }}</a> </li>
         <li><a href="https://www.getfirefox.com/" target="_blank">{{ 'SiteSupport.Browser3' | translate }}</a></li>
         <li><a href="https://www.microsoft.com/en-us/edge" target="_blank">{{ 'SiteSupport.Browser4' | translate }}</a></li>						
      </ul>
   
           

      <p>{{ 'SiteSupport.Resolution' | translate }}</p>

         <p>{{ 'SiteSupport.MobileTitle' | translate }}
            <ul>
                  <li>{{ 'SiteSupport.MobileItem1' | translate }}</li>
                  <li>{{ 'SiteSupport.MobileItem2' | translate }}</li>
                  <li>{{ 'SiteSupport.MobileItem3' | translate }}</li>
            </ul>
         
          
         <p>{{ 'SiteSupport.Download' | translate }}</p>
          
         <p>{{ 'SiteSupport.AddIns' | translate }}
          <ul>
                  <li>{{ 'SiteSupport.AddInsItem1' | translate }}</li>
                  <li>{{ 'SiteSupport.AddInsItem2' | translate }}</li>
          </ul>
         <p>{{ 'SiteSupport.Disclaimer' | translate }}</p>
         

         <p>{{ 'SiteSupport.Terms1' | translate }}<a href="https://daimler-truckfinancial.com/home/useAndPrivacy" target="_blank">{{ 'SiteSupport.Terms2' | translate }}</a>{{ 'SiteSupport.Terms3' | translate }}
         </p>      
</div>

<div class="dtfcontactus" *ngIf="isCanadaPortal">
  <div class="dtf-alertpage"></div>
    <!--Banner-->
   <section class="mbfs-home-hero"  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Website_ContactUs_Header.jpg);">
     <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle">
        {{ 'ContactUs.ContactTitle' | translate }}
       </h2>
       
        <p class="subheader">
           {{ 'ContactUs.ContactHeader' | translate }}
        </p>
       
     </section>
   </section>
   <ul *ngIf="isFrench"> <!--Canada French Brochures-->
      <div class="staticflex">
         <div>
            <div class="column-text">
               <div class="section-title by-phone-mail">{{ 'ContactUs.ByPhone' | translate }}</div>
               <div class="section-title other-titles">{{ 'ContactUs.ByPhone1' | translate }}</div>
               <div class="phone-number">{{ 'ContactUs.ByPhone2' | translate }}</div>

               <div class="section-title by-phone-mail">{{ 'ContactUs.ByEmail' | translate }}</div>
               <div class="phone-number">{{ 'ContactUs.ByEmail1' | translate }}</div>

            </div>            
         </div>

         <div>
            <div class="column-text">
               <div class="section-title by-phone-mail">{{ 'ContactUs.ByMail' | translate }}</div>
               <div class="address">{{ 'ContactUs.ByMail1' | translate }}</div>
               <div class="address">{{ 'ContactUs.ByMail2' | translate }}</div>
               <div class="address">{{ 'ContactUs.ByMail3' | translate }}</div>

               <div class="section-title by-phone-mail">{{ 'ContactUs.HoursOfOperation' | translate }}</div>
               <div class="address">{{ 'ContactUs.HoursOfOperation1' | translate }}</div>
               <div class="address">{{ 'ContactUs.HoursOfOperation2' | translate }}</div>
            </div>
         </div>
      </div>
   </ul>
   
  <!--Canada English Brochures-->
  <ul *ngIf="!isFrench">
   <div class="staticflex">
      <div>
         <div class="column-text">
            <div class="section-title by-phone-mail">{{ 'ContactUs.ByPhone' | translate }}</div>
            <div class="section-title other-titles">{{ 'ContactUs.ByPhone1' | translate }}</div>
            <div class="phone-number">{{ 'ContactUs.ByPhone2' | translate }}</div>

            <div class="section-title by-phone-mail">{{ 'ContactUs.ByEmail' | translate }}</div>
            <div class="phone-number">{{ 'ContactUs.ByEmail1' | translate }}</div>

         </div>            
      </div>

      <div>
         <div class="column-text">
            <div class="section-title by-phone-mail">{{ 'ContactUs.ByMail' | translate }}</div>
            <div class="address">{{ 'ContactUs.ByMail1' | translate }}</div>
            <div class="address">{{ 'ContactUs.ByMail2' | translate }}</div>
            <div class="address">{{ 'ContactUs.ByMail3' | translate }}</div>

            <div class="section-title by-phone-mail">{{ 'ContactUs.HoursOfOperation' | translate }}</div>
            <div class="address">{{ 'ContactUs.HoursOfOperation1' | translate }}</div>
            <div class="address">{{ 'ContactUs.HoursOfOperation2' | translate }}</div>
         </div>
      </div>
   </div>   
</ul>
<div class="section-title accessibility-footer">{{ 'ContactUs.Accessibility' | translate }}</div>
</div>
